document.addEventListener("DOMContentLoaded", function() {
    // Use event delegation to handle dynamically loaded reviews
    document.addEventListener('click', function(e) {
        // Check if the clicked element is a product link in the All Reviews widget
        if (e.target.matches('.jdgm-all-reviews-widget a[href*="/products/"]') || 
            e.target.closest('.jdgm-all-reviews-widget a[href*="/products/"]')) {
            
            e.preventDefault();
            
            // Get the actual link element (in case we clicked on a child element)
            const link = e.target.matches('a') ? e.target : e.target.closest('a');
            
            if (link && link.href) {
                // Remove any hash fragments and navigate to top of page
                window.location.href = link.href.split('#')[0];
            }
        }
    });
    
    // Also use MutationObserver to handle cases where Judge.me might replace entire sections
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                // Check if any new nodes contain Judge.me review widgets
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        const reviewWidget = node.querySelector ? node.querySelector('.jdgm-all-reviews-widget') : null;
                        if (reviewWidget || node.classList?.contains('jdgm-all-reviews-widget')) {
                            // New review content loaded, but event delegation will handle it automatically
                            console.log('New Judge.me review content detected');
                        }
                    }
                });
            }
        });
    });
    
    // Start observing the document for changes
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});